import type { LabelProps, SelectNativeProps } from '../form';
import { Field, Label, SelectNative, TextError } from '../form';
import { ErrorMessage } from '@hookform/error-message';
import type { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { get, useFormContext } from 'react-hook-form';
import { RenderedContent } from '@workspace/core-ts/utils';

export interface FieldSelectNativeProps<TFormValues extends Record<string, any> = any> 
  extends SelectNativeProps, LabelProps {
  label: RenderedContent;
  name: Path<TFormValues> | string;
  validation?: RegisterOptions<FieldValues, string>;
}

/**
 * Select natif connecté au formulaire
 * Validation automatique et gestion d'état intégrée
 */
export function FieldSelectNative({ 
  label, 
  name, 
  required = true, 
  children, 
  validation, 
  disabled, 
  ...props 
}: FieldSelectNativeProps) {
  const methods = useFormContext();

  return (
    <Field>
      <Label required={required}>{label}</Label>
      <SelectNative
        {...methods.register(name, {
          required: {
            value: required,
            message: 'Ce champs est requis',
          },
          ...validation,
        })}
        disabled={methods.formState.isSubmitting || disabled}
        error={get(methods.formState.errors, name)}
        {...props}
      />
      <ErrorMessage
        errors={methods.formState.errors}
        name={name}
        render={({ message }) => <TextError>{message}</TextError>}
      />
      {children}
    </Field>
  );
}
